<section class="popular-section" #popularSection>
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">Popular Events Happening Soon</h2>
      <p class="section-subtitle">Don't miss out on these highly-rated workshops and events</p>
    </div>

    <div *ngIf="loading" class="loading-state">
      <div class="loading-spinner"></div>
      <p>Loading popular events...</p>
    </div>

    <div *ngIf="error" class="error-state">
      <p>{{ error }}</p>
      <button (click)="loadPopularEvents()" class="retry-btn">Try Again</button>
    </div>

    <div *ngIf="!loading && !error" class="popular-events-slider">
      <div
        *ngFor="let event of popularEvents"
        class="event-card-large"
        (click)="onEventClick(event)">
        <div class="event-image">
          <img [src]="event.image" [alt]="event.title">
          <div class="event-type">{{ event.type }}</div>
          <div class="event-rating">
            <span class="stars">
              <span *ngFor="let star of getStarRating(event.rating || 0)" [class.filled]="star === '★'">{{ star }}</span>
            </span>
            <span class="rating-text">{{ event.rating }}</span>
          </div>
        </div>
        <div class="event-content">
          <h3 class="event-title">{{ event.title }}</h3>
          <p class="event-description" *ngIf="event.description">{{ event.description }}</p>
          <div class="event-details">
            <div class="event-location">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>
              <span>{{ event.location }}</span>
            </div>
            <div class="event-date">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                <line x1="16" y1="2" x2="16" y2="6"></line>
                <line x1="8" y1="2" x2="8" y2="6"></line>
                <line x1="3" y1="10" x2="21" y2="10"></line>
              </svg>
              <span>{{ event.date }}</span>
            </div>
            <div class="event-instructor" *ngIf="event.instructor">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
              <span>{{ event.instructor }}</span>
            </div>
            <div class="event-duration" *ngIf="event.duration">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12,6 12,12 16,14"></polyline>
              </svg>
              <span>{{ event.duration }}</span>
            </div>
            <div class="event-attendees" *ngIf="event.attendees">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>{{ event.attendees }} attending</span>
            </div>
          </div>
          <div class="event-footer">
            <span class="event-price">{{ event.price }}</span>
            <button class="book-btn">Book Now</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
